export default "/images/vendor/flag-icon-css/flags/1x1/tj.svg?e97716cafb6e3b770d5b939f587d026e";